import Button from './button.element.js';

export default Button;

Button.define('wje-button', Button);
